// const signalingServer = 'wss://cloud.publiduplo.com:4041/';
const signalingServer = 'wss://medislot.com:56112/';
// const signalingServer = 'ws://localhost:4040';

const peerConnectionConfig = {
    iceServers: [
        // {
        //     urls: 'turn:numb.viagenie.ca',
        //     credential: 'medislot123',
        //     username: 'geral@softlogic.pt',
        // },
        {
            urls: "stun:stun.relay.metered.ca:80",
        },
        {
            urls: "turn:standard.relay.metered.ca:80",
            username: "6cddc6f093c96f05484e28dd",
            credential: "7XUQGFxy7kTb2EyP",
        },
        {
            urls: "turn:standard.relay.metered.ca:80?transport=tcp",
            username: "6cddc6f093c96f05484e28dd",
            credential: "7XUQGFxy7kTb2EyP",
        },
        {
            urls: "turn:standard.relay.metered.ca:443",
            username: "6cddc6f093c96f05484e28dd",
            credential: "7XUQGFxy7kTb2EyP",
        },
        {
            urls: "turns:standard.relay.metered.ca:443?transport=tcp",
            username: "6cddc6f093c96f05484e28dd",
            credential: "7XUQGFxy7kTb2EyP",
        },
    ],
};

export { peerConnectionConfig, signalingServer };
